import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { MessageState } from '../../../../shared/state/message/message.store';
import { getEntityType } from '@datorama/akita';
import { MessageQuery } from '../../../../shared/state/message/message.query';
import { MessageService } from '../../../../shared/state/message/message.service';
import { Message } from '../../../../shared/state/message/message.model';
import { AlertController, ModalController, NavController, Platform } from '@ionic/angular';
import { LibraryService } from '../../../../core/services/library/library.service';
import { Router } from '@angular/router';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { CompanyService } from 'src/app/shared/state/company/company.service';
import { SettingsService } from 'src/app/shared/state/settings/settings.service';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { MessageDetailComponent } from 'src/app/modules/message-detail/pages/message-detail/message-detail.component';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
})

/**
 * TODO: Badge de mensajes
 */
export class MessageComponent implements OnInit {
    user$: Observable<UserState>;
    messages$: Observable<getEntityType<MessageState>[]>;
    isLoadingContent;
    headerPicture$;
    headerBackground$;
    headerIcon$;

    /** Flowwwer template */
    clinicName$: Observable<string>;
    showBackButtonHeader$: Observable<boolean>;

    constructor(
        private userQuery: UserQuery,
        private messageQuery: MessageQuery,
        private messageService: MessageService,
        private alertCtrl: AlertController,
        private libraryService: LibraryService,
        private router: Router,
        private settingsQuery: SettingsQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private companyService: CompanyService,
        private settingsService: SettingsService,
        private platform: Platform,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private clinicQuery: ClinicQuery,
        private navCtrl: NavController,
        private modalController: ModalController
    ) {}

    ngOnInit(): void {
        this.headerPicture$ = this.headerPictureQuery.select('messages');
        this.headerBackground$ = this.headerBackgroundQuery.select('messages');
        this.headerIcon$ = this.headerIconQuery.select('messages');
        this.user$ = this.userQuery.select();
        this.messages$ = this.messageQuery.selectAll();

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
    }

    async refreshMessages(event) {
        this.isLoadingContent = true;
        try {
            await this.messageService.getMessages(null);
        } catch (error) {
            this.isLoadingContent = false;
        }
        this.isLoadingContent = false;

        event.target.complete();
    }

    deleteMessage(message: Message) {
        this.showConfirmDelete(message);
    }

    showMessageDetails(message: Message) {
        this.router.navigate([
            this.settingsQuery.systemKeyURL +
                '/' +
                this.clinicDetailQuery.id +
                '/message-detail/' +
                message.id,
        ]);
    }

    async showMessageDetailsModal(message: Message) {
        const modal = await this.modalController.create({
            component: MessageDetailComponent,
            cssClass: this.settingsQuery.browser
                ? 'modal-flowwwer modal-browser'
                : 'modal-flowwwer',
            componentProps: {
                messageID: message.id,
                isModal: true,
            },
        });
        return await modal.present();
    }


    async showConfirmDelete(message: Message) {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            header: this.libraryService.getLabel('app_action_delete'),
            message: this.libraryService.getLabel(
                'app_message_confirm_deletion'
            ),
            buttons: [
                {
                    text: this.libraryService.getLabel('app_action_delete'),
                    role: 'confirm',
                    handler: () => {
                        this.deleteAppointmentConfirmed(message.id);
                    },
                },
                {
                    text: this.libraryService.getLabel('app_action_cancel'),
                    role: 'cancel',
                },
            ],
        });
        await alert.present();
    }

    deleteAppointmentConfirmed(messageId) {
        this.messageService.deleteMessage(messageId);
    }

    /** Flowwwer template */
    goHome(event) {
        event?.stopPropagation();
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.isPersonalized() ||
            this.clinicQuery.getValue().clinicsFound.length > 1
        ) {
            this.navCtrl.navigateBack(
                '/' +
                    (this.settingsQuery.isPersonalized()
                        ? this.settingsQuery.currentSystemKey
                        : '')
            );
        }
    }
}
